import type { LucideIcon } from "lucide-react";
import {
  Target,
  Grid2X2,
  LayoutGrid,
  Link2,
  GitCompareArrows,
  Coins,
  History,
  Calendar,
  BarChart3,
  Table,
  TrendingDown,
  Repeat,
  Activity,
  Sparkles,
  Shield,
  Calculator,
  Dices,
  BookOpen,
  CheckCheck,
  Star,
  FlaskConical,
  Download,
  Gift,
  Search,
  Menu,
  X,
  ChevronDown,
  UserRound,
} from "lucide-react";

/**
 * Map nom d'icône canonique (clé partagée avec MagHeaderRenderer::icon côté PHP)
 * → composant lucide, pour le rendu React de la nav depuis navCatalog.generated.ts.
 *
 * Les choix préservent le rendu React historique (grid→LayoutGrid, link→Link2,
 * book→BookOpen, flask→FlaskConical) ; le Twig mappe les mêmes noms vers ses
 * propres SVG. Le NOM est unifié, le pixel reste propre à chaque monde.
 */
export const NAV_ICONS: Record<string, LucideIcon> = {
  search: Search,
  menu: Menu,
  x: X,
  "chevron-down": ChevronDown,
  user: UserRound,
  target: Target,
  "grid-2x2": Grid2X2,
  grid: LayoutGrid,
  link: Link2,
  compare: GitCompareArrows,
  coins: Coins,
  history: History,
  calendar: Calendar,
  "bar-chart": BarChart3,
  table: Table,
  "trending-down": TrendingDown,
  repeat: Repeat,
  activity: Activity,
  sparkles: Sparkles,
  shield: Shield,
  calculator: Calculator,
  dices: Dices,
  book: BookOpen,
  "check-check": CheckCheck,
  star: Star,
  flask: FlaskConical,
  download: Download,
  gift: Gift,
};
